import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Download, Printer, ArrowLeft, CheckCircle2, FileText, ZoomIn, ZoomOut } from "lucide-react";
import { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";

export default function PreviewPDF() {
  const { submissionId } = useParams();
  const navigate = useNavigate();
  const [zoom, setZoom] = useState(100);

  const pdfUrl = `${API}/submissions/${submissionId}/pdf`;

  useEffect(() => {
    if (!submissionId) navigate("/pemohon");
  }, [submissionId, navigate]);

  const download = () => {
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = `SIMPA-${submissionId}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <div className="min-h-screen bg-slate-50/60">
      <Navbar variant="public" />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}>
          <div className="rounded-2xl bg-white border border-slate-200 p-6 flex flex-wrap items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-xl bg-emerald-100 text-emerald-600 grid place-items-center">
                <CheckCircle2 className="w-5 h-5" />
              </div>
              <div>
                <h1 className="text-lg font-semibold text-slate-900 tracking-tight">Formulir berhasil dibuat</h1>
                <p className="text-sm text-slate-500">Simpan atau cetak PDF Anda di bawah ini. Jangan lupa tanda tangan di atas materai Rp 10.000.</p>
              </div>
            </div>
            <div className="flex items-center gap-2 flex-wrap">
              <Link to="/pemohon" className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-slate-900 px-3 py-2" data-testid="preview-back-btn">
                <ArrowLeft className="w-4 h-4" /> Kembali
              </Link>
              <Button variant="outline" onClick={() => setZoom((z) => Math.max(60, z - 10))} className="rounded-lg" data-testid="preview-zoom-out">
                <ZoomOut className="w-4 h-4" />
              </Button>
              <div className="text-sm text-slate-600 w-14 text-center">{zoom}%</div>
              <Button variant="outline" onClick={() => setZoom((z) => Math.min(160, z + 10))} className="rounded-lg" data-testid="preview-zoom-in">
                <ZoomIn className="w-4 h-4" />
              </Button>
              <Button variant="outline" onClick={() => window.open(pdfUrl, "_blank")?.print()} className="rounded-lg" data-testid="print-pdf-btn">
                <Printer className="w-4 h-4 mr-2" /> Cetak
              </Button>
              <Button onClick={download} className="btn-lift rounded-lg bg-blue-600 hover:bg-blue-700" data-testid="download-pdf-btn">
                <Download className="w-4 h-4 mr-2" /> Unduh PDF
              </Button>
            </div>
          </div>

          <div className="mt-6 rounded-2xl bg-white border border-slate-200 p-4 sm:p-6">
            <div className="mx-auto overflow-auto rounded-lg border border-slate-200 bg-slate-100" style={{ maxHeight: "calc(100vh - 260px)" }}>
              <iframe
                title="Preview PDF"
                src={pdfUrl}
                style={{ width: `${zoom}%`, height: "1000px", border: "none", display: "block", margin: "0 auto" }}
                data-testid="preview-pdf-iframe"
              />
            </div>
            <div className="mt-4 flex items-center gap-2 text-xs text-slate-500">
              <FileText className="w-4 h-4" /> Preview PDF ukuran A4 · siap cetak
            </div>
          </div>
        </motion.div>
      </main>
    </div>
  );
}
